import React, { InputHTMLAttributes } from 'react';

import { Icon } from '~/components/icon/Icon';

import * as S from './SearchInput.styles';

export const SearchInput = ({
  placeholder,
  onClick,
}: InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <S.SearchInputRoot onClick={onClick}>
      <S.InputContainer>
        <S.SearchIcon>
          <Icon iconName="Search" size={20} />
        </S.SearchIcon>

        <S.Input
          data-testid="header-search-input"
          readOnly
          placeholder={placeholder}
        />
      </S.InputContainer>
    </S.SearchInputRoot>
  );
};
